module.exports = __webpack_public_path__ + "media/images/icons/calendar-428e0641646a6966d757348233063fcd.svg";